module.exports = __webpack_public_path__ + "img/MDR.b82653b6.png";